<template>
  <div class="header">
    <v-logo />
    <span class="inmobile-show-langselect">
      <VLangSelect />
    </span>
    <v-navigation
      v-if="$mq.resize && $mq.above(985)"
      class="header-navigation"
      v-slot:default="{ links }"
    >
      <v-navigation-item
        class="text-md"
        v-for="{ id, label, anchor, form } of links"
        :anchor="anchor"
        :form="form"
        :key="id"
      >
        {{ label | trim | toUpper }}
      </v-navigation-item>
    </v-navigation>
    <v-navigation-sidebar />
  </div>
</template>

<script>
import VLogo from '@/components/ui/VLogo'
import VNavigation from '@/components/navigation/VNavigation'
import VNavigationItem from '@/components/navigation/VNavigationItem'
import VNavigationSidebar from '@/components/navigation/VNavigationSidebar'
import VLangSelect from '@/components/langSelect/VLangSelect'

export default {
  name: 'Header',
  components: {
    VLogo,
    VNavigation,
    VNavigationItem,
    VNavigationSidebar,
    VLangSelect,
  },
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  z-index: 999;
  position: absolute;
}
.inmobile-show-langselect {
  display: none;
}

@media (max-width: 985px) {
  .inmobile-show-langselect {
    display: block;
  }
  .header {
    justify-content: space-around;
  }
}

@media (max-width: 768px) {
  .header {
    justify-content: space-between;
  }
}
</style>
